import { ArrowDownRight, ArrowRight, Leaf, ShieldCheck } from "lucide-react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { formatPrice, getHighestSnapshot } from "@/lib/price";
import type { Product } from "@/mocks/products";

export function InsightsPanel({ product }: { product: Product }): JSX.Element {
  const highest = getHighestSnapshot(product.snapshots);
  const possibleSaving =
    highest && product.latestPrice !== null ? highest.price - product.latestPrice : 0;

  const items = [
    {
      icon: <ShieldCheck className="h-5 w-5" />,
      title: "Price is at 30-day low",
      body: "Great time to buy!",
      color: "from-[#4d38b8] to-[#25174e]",
    },
    {
      icon: <ArrowDownRight className="h-5 w-5" />,
      title: "Downward trend",
      body: "Price dropped 1.79% in last 30 days.",
      color: "from-[#982a2a] to-[#351013]",
    },
    {
      icon: <Leaf className="h-5 w-5" />,
      title: "Save more",
      body: `You could save up to ${formatPrice(possibleSaving)} vs highest price.`,
      color: "from-[#157a31] to-[#0b3218]",
    },
  ];

  return (
    <Card className="rounded-lg border-[#20304a] bg-[#071120] shadow-[inset_0_1px_0_rgba(255,255,255,0.04)]">
      <CardHeader className="px-5 pt-5">
        <CardTitle className="text-lg font-extrabold text-white">Insights</CardTitle>
      </CardHeader>
      <CardContent className="grid gap-4 px-5 pb-5">
        {items.map((item) => (
          <div
            className="grid grid-cols-[44px_minmax(0,1fr)] items-center gap-4 rounded-lg border border-[#20304a] bg-[#081323] p-3"
            key={item.title}
          >
            <span
              className={`grid h-11 w-11 place-items-center rounded-full bg-gradient-to-br ${item.color} text-white shadow-[0_12px_30px_rgba(0,0,0,0.32)]`}
            >
              {item.icon}
            </span>
            <span className="grid min-w-0 gap-1">
              <strong className="text-sm font-extrabold text-white">{item.title}</strong>
              <span className="text-sm leading-5 text-[#a0abbd]">{item.body}</span>
            </span>
          </div>
        ))}
        <button
          className="inline-flex h-10 items-center justify-center gap-2 rounded-md border border-[#20304a] bg-[#071120] text-sm font-extrabold text-white hover:bg-[#0b182a]"
          type="button"
        >
          View full analytics
          <ArrowRight className="h-4 w-4" />
        </button>
      </CardContent>
    </Card>
  );
}
